/* buzzlab® storefront behaviour (ported from the static landing page, wired to real Shopify variants). */
(function () {
  'use strict';
  if (window.__bzsLoaded) return; // script tag is included by several sections
  window.__bzsLoaded = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var main = $('[data-bzs-main-img]', root);
    if (!main) return;
    var gv = $('[data-bzs-gallery-video]', root), gvid = gv && $('video', gv);
    function hideVideo() {
      if (!gv) return;
      if (gvid && !gvid.paused) gvid.pause();
      gv.hidden = true; main.style.visibility = '';
    }
    $$('[data-bzs-thumb]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('data-bzs-thumb-video') && gvid) {
          if (!gvid.getAttribute('src')) { gvid.src = gvid.dataset.src; }
          gv.hidden = false; main.style.visibility = 'hidden';
          gvid.muted = true; // user-initiated, but start silent; native controls let them unmute
          var pr = gvid.play(); if (pr && pr.catch) pr.catch(function () {});
        } else {
          hideVideo();
          main.src = btn.dataset.src;
          if (btn.dataset.srcset) main.srcset = btn.dataset.srcset; else main.removeAttribute('srcset');
          main.alt = btn.dataset.alt || '';
        }
        $$('[data-bzs-thumb]', root).forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });
  }


  /* ---------- Product video section (lazy, muted autoplay loop, sound toggle) ---------- */
  function initVideo(frame) {
    var v = $('video', frame), btn = $('[data-bzs-vid-sound]', frame), label = $('[data-bzs-vid-sound-label]', frame);
    if (!v || frame.__bzsInit) return; frame.__bzsInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inView = false, userPaused = false, autoPausing = false;
    v.muted = true;
    function ensureSrc() { if (!v.getAttribute('src')) { v.src = v.dataset.src; } }
    function tryPlay() { ensureSrc(); var pr = v.play(); if (pr && pr.catch) pr.catch(function () { v.controls = true; }); }
    function syncBtn() {
      if (!btn) return;
      var on = !v.muted;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      if (label) label.textContent = on ? 'Sound off' : 'Sound on';
      btn.setAttribute('aria-label', on ? 'Mute video' : 'Turn sound on');
    }
    if (reduce) { v.controls = true; }
    v.addEventListener('click', function () { if (!v.controls) { v.controls = true; } });
    v.addEventListener('pause', function () { if (!autoPausing && inView) userPaused = true; autoPausing = false; });
    v.addEventListener('play', function () { userPaused = false; });
    v.addEventListener('volumechange', syncBtn);
    if (btn) btn.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted) { v.controls = true; if (v.paused) tryPlay(); }
      syncBtn();
    });
    syncBtn();
    if (!('IntersectionObserver' in window)) { ensureSrc(); if (!reduce) tryPlay(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        inView = e.isIntersecting;
        if (inView) {
          ensureSrc();
          if (!reduce && !userPaused && v.paused) tryPlay();
        } else if (!v.paused) { autoPausing = true; v.pause(); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.25 }).observe(frame);
  }

  /* ---------- Buy box ---------- */
  var current = null; // { id, qty, price, compare, title, currency }

  function syncGlobal() {
    if (!current) return;
    var url = '/cart/' + current.id + ':' + current.qty;
    $$('[data-bzs-buynow-global]').forEach(function (a) { a.href = url; });
    $$('.js-selected-price').forEach(function (el) { el.textContent = money(current.price * current.qty, current.currency); });
  }

  function initBuyBox(root) {
    var form = $('form[data-bzs-form]', root);
    if (!form) return;
    var currency = root.dataset.currency || 'USD';
    var qtyInput = $('input[name="quantity"]', form);
    var buyNow = $('[data-bzs-buynow]', root);
    var nowEl = $('[data-bzs-price-now]', root), wasEl = $('[data-bzs-price-was]', root), noteEl = $('[data-bzs-price-note]', root);
    var addBtn = $('[data-bzs-add]', form);

    function selected() { return $('input[name="id"]:checked', form); }
    function qty() { var v = parseInt(qtyInput.value, 10); return isNaN(v) ? 1 : Math.max(1, Math.min(10, v)); }

    function update(fromUser) {
      var r = selected();
      if (!r) return;
      var q = qty();
      qtyInput.value = q;
      var price = parseInt(r.dataset.price, 10), compare = parseInt(r.dataset.compare || '0', 10);
      $$('.bundle', form).forEach(function (l) { l.classList.toggle('is-selected', l.contains(r)); });
      nowEl.textContent = money(price * q, currency);
      if (compare > price) { wasEl.hidden = false; wasEl.textContent = money(compare * q, currency); } else { wasEl.hidden = true; }
      noteEl.textContent = (q > 1 ? q + ' \u00d7 ' : '') + r.dataset.title + (r.dataset.sub ? ' \u00b7 ' + r.dataset.sub : '');
      var available = r.dataset.available === 'true';
      if (addBtn) addBtn.disabled = !available;
      if (buyNow) { buyNow.href = '/cart/' + r.value + ':' + q; buyNow.classList.toggle('is-disabled', !available); }
      current = { id: r.value, qty: q, price: price, compare: compare, title: r.dataset.title, currency: currency };
      syncGlobal();
      if (fromUser && root.dataset.updateUrl === 'true' && window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', r.value); history.replaceState({}, '', u.toString());
      }
      document.dispatchEvent(new CustomEvent('bzs:variant', { detail: current }));
    }

    $$('input[name="id"]', form).forEach(function (r) { r.addEventListener('change', function () { update(true); }); });
    $$('[data-bzs-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = qty() + parseInt(b.dataset.bzsQty, 10); update(true); });
    });
    qtyInput.addEventListener('change', function () { update(true); });
    update(false);

    // Mobile sticky bar: show once the buy box has scrolled past (and hide near the final CTA).
    var bar = $('[data-bzs-mobile-bar]', root);
    var finalCta = $('.final-cta');
    if (bar && 'IntersectionObserver' in window) {
      var boxVisible = true, ctaVisible = false;
      var sync = function () {
        var show = !boxVisible && !ctaVisible;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('a', bar).forEach(function (a) { a.tabIndex = show ? 0 : -1; });
      };
      new IntersectionObserver(function (en) { boxVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; sync(); }).observe(form);
      if (finalCta) new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; sync(); }).observe(finalCta);
    }
  }

  /* ---------- Lightbox ---------- */
  function initLightbox() {
    var links = $$('[data-bzs-lightbox]');
    if (!links.length) return;
    var box = document.createElement('div');
    box.className = 'bzs-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<button type="button" aria-label="Close">\u00d7</button><img alt=""><p></p>';
    document.body.appendChild(box);
    var img = $('img', box), cap = $('p', box), lastFocus = null;
    function close() { box.classList.remove('open'); img.removeAttribute('src'); if (lastFocus) lastFocus.focus(); }
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        lastFocus = a;
        img.src = a.getAttribute('href');
        img.alt = a.dataset.alt || '';
        cap.textContent = a.dataset.caption || '';
        box.classList.add('open');
        $('button', box).focus();
      });
    });
    box.addEventListener('click', function (e) { if (e.target !== img) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('open')) close(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-bzs-hero]').forEach(function (root) { initGallery(root); initBuyBox(root); });
    $$('[data-bzs-video]').forEach(initVideo);

    // Header: shadow on scroll + mobile menu
    var header = $('[data-bzs-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var toggle = $('[data-bzs-nav-toggle]', header);
      if (toggle) toggle.addEventListener('click', function () {
        var open = header.classList.toggle('nav-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // FAQ: close others when one opens
    $$('.bz-faq details, .bzs .faq details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) $$('details', d.parentNode).forEach(function (o) { if (o !== d) o.open = false; });
      });
    });

    initLightbox();

    // Reviews: collapse long texts behind "Read more" (full text stays in the page).
    $$('[data-rv-text]').forEach(function (el) {
      var btn = el.parentNode.querySelector('[data-rv-more]');
      if (!btn) return;
      el.classList.add('is-clamped');
      if (el.scrollHeight <= el.clientHeight + 4) { el.classList.remove('is-clamped'); return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read more';
      });
    });
  });
})();
